import { createI18n } from 'vue-i18n'
import en from './locales/en.json'

export const SUPPORTED_LOCALES = [
  'en', 'es', 'fr', 'de', 'uk', 'ru', 'pl', 'pt', 'el', 'ar',
]

export const LOCALE_NAMES: Record<string, { name: string; native: string; rtl: boolean }> = {
  en: { name: 'English', native: 'English', rtl: false },
  es: { name: 'Spanish', native: 'Español', rtl: false },
  fr: { name: 'French', native: 'Français', rtl: false },
  de: { name: 'German', native: 'Deutsch', rtl: false },
  uk: { name: 'Ukrainian', native: 'Українська', rtl: false },
  ru: { name: 'Russian', native: 'Русский', rtl: false },
  pl: { name: 'Polish', native: 'Polski', rtl: false },
  pt: { name: 'Portuguese', native: 'Português', rtl: false },
  el: { name: 'Greek', native: 'Ελληνικά', rtl: false },
  ar: { name: 'Arabic', native: 'العربية', rtl: true },
}

export const i18n = createI18n({
  legacy: false,
  locale: 'en',
  fallbackLocale: 'en',
  messages: { en },
})

const loadedLocales = new Set(['en'])

export async function loadLocaleMessages(locale: string): Promise<void> {
  if (loadedLocales.has(locale)) return

  const messages = await import(`./locales/${locale}.json`)
  i18n.global.setLocaleMessage(locale, messages.default)
  loadedLocales.add(locale)
}
